/* eslint-disable react/prop-types */
import React from "react";
import dataSuccess from "data/dataSuccess";
import MaPrimeRenovBlock from "components/success/MaPrimeRenovBlock";
import ErrorHandler from "components/ErrorHandler";
import NavSuccess from "components/success/NavSuccess";
import SuccessTemplateSidebar from "components/success/SuccessTemplateSidebar";
import FileUploaderAuto from "components/success/FileUploaderAuto";
import PrimeBlock from "components/success/PrimeBlock";
import BonificationBanner from "components/bonification/BonificationBanner";
import PrimeBonifieMention from "components/bonification/PrimeBonifieMention";
import PoitouCheckbox from "components/success/PoitouCheckbox";
import CreateAccount from "components/success/CreateAccount";
import { getNumericValue, formatEUR } from "utils/number";

class SuccessNormal extends React.Component {
  showMention() {
    // Affiche la mention si le type de logement est un appartement et que le système de chauffage est une pompe à chaleur eau/eau
    return (
      this.props.answers.Q2 === "Appartement" &&
      this.props.answers.Q45 &&
      this.props.answers.Q45.includes("eau/eau")
    );
  }

  render() {
    const bgMobile = `url(${dataSuccess[this.props.success].imgMobile})`;

    if (this.props.result.success === "false") {
      return (
        <ErrorHandler
          message={this.props.result.message}
          reset={this.props.reset}
        />
      );
    } else {
      const APIresult = this.props.result.data;
      const maPrimeRenov = getNumericValue(
        APIresult["Montant MPR unitaire (€)"],
      );
      const primeCEE = getNumericValue(
        APIresult["Montant prime CEE unitaire (€)"],
      );
      const montantPromo = getNumericValue(
        this.props.resultCodePromo.data.montant_promo,
      );
      const coutTravaux = getNumericValue(
        this.props.answers.Q43
          ? this.props.answers.Q43
          : APIresult["Coût travaux unitaire (€)"],
      );
      const resteACharge = getNumericValue(
        APIresult["Reste à charge unitaire (€)"],
      );
      const resteAChargePromo = getNumericValue(
        this.props.resultCodePromo.data.reste_a_charge,
      );

      const hasPrime = maPrimeRenov + primeCEE + montantPromo > 0;

      const CDP = APIresult.CDP;
      const CDB = APIresult.CDB;
      const mentionFenetre =
        APIresult.Offre === "isolation des fenêtres ou porte-fenêtre";
      // const deposeChaudiere = ["pompe à chaleur air/eau", "pompe à chaleur eau/eau", "chaudière biomasse", "pompe à chaleur hybride", "système solaire combiné"].includes(APIresult["Offre"])
      const simulerTravaux = this.props.answers.Q30 === "simulationTravaux";
      const primeS = this.props.answers.Q30 === "primeHellio";
      const postalCode = this.props.answers?.Q26?.postalcode;
      const inDep =
        postalCode &&
        (postalCode.slice(0, 2) === "86" || postalCode.slice(0, 2) === "37");
      // console.log('deposeChaudiere', deposeChaudiere, 'APIresult offre', APIresult["Offre"] )
      const deposeChaudiereMention =
        CDB && !CDP && !primeS && mentionFenetre
          ? "Cette estimation inclut la dépose de l'ancienne chaudière, la fourniture et la pose de la nouvelle chaudière ainsi que la mise en conformité de la chaufferie. Les montants de travaux et de primes peuvent varier en fonction de la surface chauffée, de la zone géographique du chantier, ou des revenus du ménage. Un artisan partenaire RGE précisera ces estimations ainsi que la faisabilité technique du chantier lors d'une visite technique gratuite et sans engagement."
          : !CDB && CDP && !primeS && mentionFenetre
            ? "Cette estimation inclut la dépose de l'ancienne chaudière, la fourniture et la pose du matériel ainsi que la mise en conformité de la chaufferie. Les montants de travaux et de primes peuvent varier en fonction de la surface chauffée, de la zone géographique du chantier, ou des revenus du ménage. Un artisan partenaire RGE précisera ces estimations ainsi que la faisabilité technique du chantier lors d'une visite technique gratuite et sans engagement."
            : !primeS && !mentionFenetre
              ? "Cette estimation inclut la fourniture et la pose du matériel ainsi que la mise en conformité de la chaufferie. Les montants de travaux et de primes peuvent varier en fonction de la surface chauffée, de la zone géographique du chantier, ou des revenus du ménage. Un artisan partenaire RGE précisera ces estimations ainsi que la faisabilité technique du chantier lors d'une visite technique gratuite et sans engagement."
              : "";
      const isFenetre =
        APIresult.Offre === "isolation des fenêtres ou porte-fenêtre";
      const mentionWithPrime =
        "Ces montants de primes sont des estimations, les aides financières sont susceptibles de varier selon le type de matériel installé. Sorégies confirmera votre montant de prime avec votre devis et votre revenu fiscal de référence validés";
      const mention =
        primeCEE === 0
          ? "La prime Sorégies pour la pompe à chaleur eau/eau n'est éligible que pour les maisons individuelles construites il y a plus de deux ans."
          : deposeChaudiereMention;
      // : `${dataSuccess[this.props.success]['paragraph']} ${dataSuccess[this.props.success]['paragraphBold'] ? dataSuccess[this.props.success]['paragraphBold']: ''}`;

      return (
        <div className="flex-container">
          <SuccessTemplateSidebar
            success={this.props.success}
            lastStep={this.props.lastStep}
            codePromo={this.props.codePromo}
            handleCodePromo={this.props.handleCodePromo}
            validCodePromo={this.props.validCodePromo}
            resultCodePromo={this.props.resultCodePromo}
            isPrime={this.props.isPrime}
          >
            <div className="success-item">
              <h3>Type de logement</h3>
              <h2>{this.props.Q2}</h2>
            </div>
            {this.props.surface && !this.props.isPrime && (
              <div className="success-item">
                <h3>Surface du logement </h3>
                <h2>
                  {this.props.surface} m
                  <sup style={{ fontSize: "0.7em" }}>2</sup>
                </h2>
              </div>
            )}

            {this.props.Q47 && this.props.isPrime && (
              <div className="success-item">
                <h3>Surface chauffée </h3>
                <h2>
                  {this.props.Q47} m<sup style={{ fontSize: "0.7em" }}>2</sup>
                </h2>
              </div>
            )}

            <div className="success-item">
              <h3>Système de chauffage principal</h3>
              <h2>{this.props.Q22}</h2>
            </div>
            <MaPrimeRenovBlock
              color={this.props.result.data["Couleur MPR"]}
            ></MaPrimeRenovBlock>

            {this.props.Q46 && (
              <div className="success-item">
                <h3>Nombre de fenêtres</h3>
                <h2>{this.props.Q46}</h2>
              </div>
            )}
          </SuccessTemplateSidebar>
          <div className="success-right-container">
            <BonificationBanner APIresult={APIresult}></BonificationBanner>
            <div
              className={`success-item-right mt-5 ${!hasPrime ? "!mb-0 !border-0" : ""}`}
            >
              <h5>
                {this.props.success === "AuditEnergetique" ||
                this.props.success === "RenovationGlobale"
                  ? "Coût de l’audit énergétique"
                  : "Estimation du coût de mes travaux"}
              </h5>
              <div>
                <h5 className="h5-price whitespace-nowrap">
                  {formatEUR(coutTravaux)}
                </h5>
              </div>
            </div>
            <PrimeBlock
              APIresult={APIresult}
              success={this.props.success}
              resultCodePromo={this.props.resultCodePromo}
            />
            {/* Normal reste a Payer */}
            {resteACharge !== 0 && hasPrime && resteAChargePromo === 0 && (
              <div className="success-item-right last">
                <h5>Reste à payer</h5>
                <div>
                  <h5 className="h5-price whitespace-nowrap">
                    {formatEUR(resteACharge)}
                  </h5>
                </div>
              </div>
            )}
            {/* reste a Payer avec Code promo */}
            {resteACharge !== 0 && resteAChargePromo !== 0 && (
              <div className="success-item-right last">
                <h5>Reste à payer</h5>
                <div>
                  <h5 className="h5-price whitespace-nowrap">
                    {formatEUR(resteAChargePromo)}
                  </h5>
                </div>
              </div>
            )}
            {this.props.showFile && hasPrime && (
              <FileUploaderAuto
                patchName="fileImposition"
                description="Déposez votre avis imposition pour valider le montant de votre prime"
                handleFile={this.props.handleFile}
                result={this.props.result}
                firstname={this.props.contact.firstname}
                lastname={this.props.contact.lastname}
              ></FileUploaderAuto>
            )}
            <NavSuccess
              callBtn={this.props.callBtn}
              lastStep={this.props.lastStep}
              date={this.props.date}
              creneau={this.props.creneau}
              handleDate={this.props.handleDate}
              handleCreneau={this.props.handleCreneau}
            ></NavSuccess>
            {simulerTravaux && inDep && (
              <h5 className="paragraph mv-10">
                <a
                  href="https://www.soregies.fr/concretiser-vos-travaux-partenaires-rge/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-main"
                >
                  {`J'ai besoin d'une entreprise de travaux RGE`}
                </a>
              </h5>
            )}
            {isFenetre && hasPrime && (
              <p className="paragraph mv-10">
                La prime est estimée sur la base d’une surface moyenne de
                fenêtre
              </p>
            )}
            <PrimeBonifieMention APIresult={APIresult}></PrimeBonifieMention>
            {this.showMention() && <p className="paragraph">{mention}</p>}
            {primeCEE > 0 && (
              <p className="paragraph mt-10">{mentionWithPrime}</p>
            )}
            <PoitouCheckbox
              answers={this.props.answers}
              result={this.props.result}
              bodyData={this.props.bodyData}
            />

            <CreateAccount
              simulationId={this.props.simulationId}
              simulationCode={this.props.simulationCode}
              contact={this.props.contact}
            />
          </div>
          <div
            style={{
              backgroundImage: bgMobile,
            }}
            className="success-header-img only-show-mobile"
          >
            <h1>{dataSuccess[this.props.success].h1}</h1>
          </div>
        </div>
      );
    }
  }
}

export default SuccessNormal;
